module.exports = __webpack_public_path__ + "static/img/plan5.1f02ac1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/plan5.png
// module id = kpHt
// module chunks = 1